import React from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";

function Revolutionindustries(props) {
  return (
    <section className="tekgrip_section tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={10} lg={10} xl={10} xxl={10}>
            <div className="example" data-text="Features Part">
              <h2>
                On-Demand Fintech Software Development Services with Unique
                Features
              </h2>
            </div>
            <p className="main_para">
              Our UX-focused approach to Fintech software development ensures
              that every product we create satisfies stakeholders' expectations
              and includes all of the innovative features that define our
              exceptional Fintech software solutions.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Tab.Container defaultActiveKey="0">
              <Row>
                <Col xs={12} md={6} lg={6} xl={6}>
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="0">Wealth Management</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="1">CryptoTrading</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="2">Bio-Metric Verification</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="3">
                        Peer-to-Peer Transactions
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="4">Insurtech</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                  <Tab.Content>
                    <Tab.Pane eventKey="0">
                      <p>
                        A fintech development company develops protection wealth
                        management software systems with the latest privacy and
                        security features to ensure that users can review their
                        budget, detect new investment opportunities, and decide
                        on best-performing investments through data-based
                        analysis.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="1">
                      <p>
                        The fact that we are unique among the other Fintech
                        software development companies is that we believe in the
                        power of blockchain and cryptocurrencies. Our Fintech
                        company provides the software for building
                        blockchain-based smart contracts for digital
                        marketplaces where people can buy and sell NFTs and
                        cryptocurrencies with much comfort.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="2">
                      <p>
                        We integrate advanced biometric verification features in
                        our Fintech software development to enable users to log
                        in quickly and moderate the chances of unauthorized
                        login attempts and data breaches. Our developers
                        integrate advanced tech like AI and ML to allow various
                        biometric solutions like face recognition features,
                        fingerprint solutions, and others.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="3">
                      <p>
                        Users can access their LMS dashboard offline and watch
                        downloaded videos and courses in case of power breakdown
                        or connectivity issues. The offline mode ensures that
                        users don't get any resistance to learning and
                        development no matter what!
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="4">
                      <p>
                        Being a leading Fintech software development agency, we
                        help financial institutions and insurance companies
                        become future-ready by developing innovative InsurTech
                        software products. We offer user-friendly insurance
                        software that works perfectly across multiple platforms.
                        Our goal is to deliver an exceptional experience for
                        insurance firms, their clients, partners, stakeholders,
                        and staff.
                      </p>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Revolutionindustries;
